import { createContext, useContext, useState } from 'react';

const OverlayContext = createContext();

const OverlayProvider = ({ children }) => {
  const [nodes, setNodes] = useState(null);

  const clearChildNodes = () => setNodes(null);

  const setChildNodes = nodes => setNodes(nodes);

  return (
    <OverlayContext.Provider value={{ nodes, clearChildNodes, setChildNodes }}>
      {children}
    </OverlayContext.Provider>
  );
};

const useOverlay = () => useContext(OverlayContext);

export { OverlayProvider, useOverlay };
